// todo: ストレージのファイル名にドメイン名を露出させているが、より適切な名称があれば変更したい
//  詳しくはPRの議論を参考: https://github.com/ubie-inc/sushiro/pull/156#discussion_r1814252417

import { GoogleAppointmentConversionTracking } from '~/models/GoogleAppointmentConversionTracking';
import { AppointmentDraft } from '~/models/AppointmentDraft';
import { generateJsonTransformer, LocalStorage, SessionStorage } from '~/utils/storage/storage';
import { MedicoUser } from '~/models/MedicoUser';
import { OfroFlags } from '~/models/OfroFlags';
import { MedicoUserAuth } from '~/models/MedicoUserAuth';
import { AppointmentClinicBanner } from '~/models/AppointmentClinicBanner';

export const googleAppointmentConversionTrackingStorage = new LocalStorage<GoogleAppointmentConversionTracking>({
  key: 'reservation-conversion-tracking',
  transformer: generateJsonTransformer(),
});

export const appointmentDraftStorage = new SessionStorage<AppointmentDraft>({
  key: 'appointment-draft',
  transformer: generateJsonTransformer((key, value) => {
    if (key === 'visitDate') return new Date(value as string);
    return value;
  }),
});

// 集患サポートでは、スマホ問診のログイン情報ではなく、medicoのログイン情報を使用する。
// 実質的にはこの2つは違いはない（medicoでログインしてる状態で、スマホ問診のログインをすると、medicoと同じユーザでログインされるため）。
// しかし、集患サポートはubie.appで提供されるため、スマホ問診(inquiry.ubie.app)の情報を参照できない。
// なので、medicoのログイン情報を使用することになる。
export const medicoUserStorage = new LocalStorage<MedicoUser>({
  key: 'medico-user',
  transformer: generateJsonTransformer(),
});
export const medicoUserAuthStorage = new LocalStorage<MedicoUserAuth>({
  key: 'ubie-auth',
  transformer: generateJsonTransformer(),
});

export const appointmentClinicBannerStorage = new LocalStorage<AppointmentClinicBanner>({
  key: 'appointment-clinic-banner',
  transformer: generateJsonTransformer(),
});

// 開発者モードなどのofroのフラグ情報はローカルストレージで共有する。
export const ofroFlagsStorage = new LocalStorage<OfroFlags>({
  key: 'ofro-flags',
  transformer: generateJsonTransformer(),
});
